import { NgModule } from "@angular/core";
import { NumberInputDirective } from "./number-input.directive";
import { SafeTextInputDirective } from "./safe-text-input.directive";
import { DatePickerInputDirective } from "@core/directive/datepicker-input.directive";
import { DigitOnlyInputDirective } from "@core/directive/digit-only-input.directive";
import { SafeHtmlPipe } from "@core/directive/safe-html.directive";
import { SessionReviveInputDirective } from "@core/directive/session-revive-input.directive";
import { SessionReviveClickDirective } from "@core/directive/session-revive-click.directive";

@NgModule({
  declarations: [
    NumberInputDirective,
    DigitOnlyInputDirective,
    SafeTextInputDirective,
    DatePickerInputDirective,
    SafeHtmlPipe,
    SessionReviveClickDirective,
    SessionReviveInputDirective
  ],
  exports: [
    NumberInputDirective,
    DigitOnlyInputDirective,
    SafeTextInputDirective,
    DatePickerInputDirective,
    SafeHtmlPipe,
    SessionReviveClickDirective,
    SessionReviveInputDirective
  ]
})
export class DirectiveModule {
}
